




























































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "GameCard",
})
export default class GameCard extends Vue {
  @Prop({ default: () => null }) number!: number;
  @Prop({ default: () => true }) revealed!: boolean;
}
